import { fetch } from '@/utils/fetch';

// /**
//  * 查询列表
//  * @returns {Promise<Response>}
//  */
// export function _queryGoodsAttributes(
//   {
//     page, size, direction, sort,
//   },
// ) {
//   return fetch({
//     url: `${process.env.VUE_APP_BASE_URL}/goods-attributes`,
//     method: 'get',
//     params: {
//       page,
//       size,
//       direction,
//       sort,
//     },
//   });
// }
//
// /**
//  * 根据 id 查询
//  * @returns {Promise<Response>}
//  */
// export function _queryGoodsAttribute(goodsAttributeId) {
//   return fetch({
//     url: `${process.env.VUE_APP_BASE_URL}/goods-attributes/${goodsAttributeId}`,
//     method: 'get',
//   });
// }
//
// /**
//  * 新增
//  * @param  categoryId
//  * @param  name
//  * @returns {Promise<*|undefined>}
//  * @private
//  */
// export function _addGoodsAttribute(
//   {
//     name,
//     code,
//   },
// ) {
//   return fetch({
//     url: `${process.env.VUE_APP_BASE_URL}/goods-attributes`,
//     method: 'post',
//     data: {
//       name,
//       code,
//     },
//   });
// }
//
// /**
//  * 更新
//  * @param categoryId
//  * @param  goodsAttributeId
//  * @param  name
//  * @returns {Promise<*|undefined>}
//  * @private
//  */
// export function _updateGoodsAttribute(goodsAttributeId, {
//   name,
//   code,
//   isActive,
// }) {
//   return fetch({
//     url: `${process.env.VUE_APP_BASE_URL}/goods-attributes/${goodsAttributeId}`,
//     method: 'patch',
//     data: {
//       name,
//       code,
//       isActive,
//     },
//   });
// }
//
// /**
//  * 删除
//  * @param categoryId
//  * @param goodsAttributeId
//  * @returns {Promise<*|undefined>}
//  * @private
//  */
// export function _deleteGoodsAttribute(goodsAttributeId) {
//   return fetch({
//     url: `${process.env.VUE_APP_BASE_URL}/goods-attributes/${goodsAttributeId}`,
//     method: 'delete',
//   });
// }

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsAttributes(
  goodsId,
  {
    page,
    size,
    direction,
    sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/goods-attributes`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsAttribute(goodsId, goodsAttributeId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/goods-attributes/${goodsAttributeId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  goodsId
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsAttribute(
  goodsId,
  {
    name,
    code,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/goods-attributes`,
    method: 'post',
    data: {
      name,
      code,
    },
  });
}

/**
 * 更新
 * @param goodsId
 * @param  goodsAttributeId
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsAttribute(goodsId, goodsAttributeId, {
  name,
  code,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/goods-attributes/${goodsAttributeId}`,
    method: 'patch',
    data: {
      name,
      code,
    },
  });
}

/**
 * 删除
 * @param goodsId
 * @param goodsAttributeId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsAttribute(goodsId, goodsAttributeId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/goods-attributes/${goodsAttributeId}`,
    method: 'delete',
  });
}

export default {};
